<template>
  <v-layout justify-center>
    <div v-if="isCommChair">
      <v-flex xs12>
        <v-layout v-if="isCommChair">
          <v-flex xm12 sm4 class="title text-xs-center text-sm-left align-center">
            <v-select
              :items="searchSelect"
              v-model="searchType"
              label="Year"
              small
              solo
              outline
              @change="searchYear"
            ></v-select>
          </v-flex>
          <v-flex xm12 md4 class="text-sm-center">
            <span class="headline">Vendor</span><br />
          </v-flex>
          <v-flex xm12 sm4 class="title text-xs-center text-sm-left align-center">
            <v-select
              :items="getPage"
              v-model="currentPage"
              label="Page"
              small
              solo
              outline
              @change="getCurrentPage"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-flex>

      <List
        v-if="isList"
        :visible="isList"
        :currentYear="currentYear"
      />

      <Booth
        v-if="isBooth"
        :visible="isBooth"
        :currentYear="currentYear"
      />

      <Maps
        v-if="isMap"
        :visible="isMap"
        :currentYear="currentYear"
      />

      <Accounting
        v-if="isAccounting"
        :visible="isAccounting"
        :currentYear="currentYear"
      />

      <Reports
        :visible="isReports"
        :currentYear="currentYear"
        @close="closeThis"
      />

      <Settings
        v-if="isSettings"
        :visible="isSettings"
      />
    </div>
    <div v-else>You Do not have access to this!</div>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import List from './List.vue'
import Booth from './Booths.vue'
import Maps from './Maps.vue'
import Accounting from './Accounting.vue'
import Settings from './Settings.vue'
import Reports from './Reports.vue'

export default {
  components: {
    List,
    Booth,
    Maps,
    Accounting,
    Reports,
    Settings
  },
  data () {
    return {
      valid: true,
      myId: this.$store.state.user.id,
      page: 'Vendor Page',
      currentPage: 'List',
      getPage: ['List', 'Booth', 'Maps', 'Accounting', 'Shipping', 'Reports', 'Settings'],
      currentYear: 0,
      searchSelect: [],
      searchType: '',
      isAdmin: this.$store.state.isAdmin,
      isCommChair: false,
      isList: true,
      isBooth: false,
      isMap: false,
      isAccounting: false,
      isSettings: false,
      isReports: false
    }
  },

  created () {
    this.currentYear = this.$store.state.currentYear
    this.searchType = this.$store.state.currentYear
    this.yearList()

    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    this.getMembers()
  },

  mounted () {
    this.isMounted = true
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    yearList () {
      for (let i = this.$store.state.currentYear; i >= 2013; i--) {
        this.searchSelect.push(i)
      }
    },

    searchYear () {
      this.currentYear = this.searchType
    },

    getCurrentPage () {
      this.isList = false
      this.isBooth = false
      this.isMap = false
      this.isAccounting = false
      this.isSettings = false
      this.isReports = false

      if (this.currentPage === 'List') {
        this.isList = true
      }

      if (this.currentPage === 'Booth') {
        this.isBooth = true
      }

      if (this.currentPage === 'Maps') {
        this.isMap = true
      }

      if (this.currentPage === 'Accounting') {
        this.isAccounting = true
      }

      if (this.currentPage === 'Settings') {
        this.isSettings = true
      }

      if (this.currentPage === 'Reports') {
        this.isReports = true
      }
    },

    async getMembers () {
      try {
        this.isCommChair = this.isAdmin
        let item = {}
        let control = {}

        const controls = this.$store.state.controls
        control = controls.find(item => item === 'Vendor')

        if (control) {
          this.isCommChair = true
        } else {
          const response = await Api().get('get_committee_by_code/VEN/' + this.currentYear)
          this.memberList = response.data.committee.Users

          item = this.memberList.find(item => item.id === this.myId)

          if (item.UserCommittee.title === 'Chair' || item.UserCommittee.title === 'Assist Chair') {
            this.isCommChair = true
          }
        }
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    handleResize () {
      const height = window.innerHeight - 300
      this.height = height + 'px'
    },

    closeThis () {
      this.isReports = false
      this.currentPage = 'List'
      this.getCurrentPage()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/vendor/Enter.vue